module.exports = __webpack_public_path__ + "static/media/vzw-calc-logo.4f5105d0.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/TCH-WEB/vzw-calc-logo.svg
// module id = 1305
// module chunks = 0